import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DS_DEMO_DNA2_8 = {
  title:
    "After reviewing the pipeline from \nVignesh, Vivian is impressed and \nwishes to automate the pipeline \nbuilding process.",
  subtitle: "Data STREAMS demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(213),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(211),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA2/DNA2_DS_DEMO_08_computer.png",
          imageStyle: {
            position: "absolute",
            right: "77.78px",
            bottom: "178px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_08_screen.png",
          imageStyle: {
            position: "absolute",
            right: "78.2px",
            bottom: "49.66px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_08_bubble_accuracy.png",
          imageStyle: {
            position: "absolute",
            right: "357.77px",
            bottom: "682.75px",
          },
        },
        {
          image: "DNA2/DNA2_DS_DEMO_08_bubble_innovation.png",
          imageStyle: {
            position: "absolute",
            right: "165.06px",
            bottom: "784.39px",
          },
        },
        {
          image: "DNA2/DNA2_DS_DEMO_08_bubble_automation.png",
          imageStyle: {
            position: "absolute",
            right: "568.73px",
            bottom: "753.75px",
          },
        },
        {
          image: "DNA2/DNA2_DS_DEMO_08_bubble_speed.png",
          imageStyle: {
            position: "absolute",
            right: "482px",
            bottom: "841.37px",
          },
        },
      ]}
      pageNumber={212}
    />
  ),
};
